<template>
  <div class="qwContacts">
    <div
      v-for="(item, index) in datas"
      :key="index"
    >
      <!-- {{item[openid]}} -->
      <ww-open-data
        :type="type"
        :openid="item[openid]"
        @click="setOpenData"
      />
    </div>
  </div>
</template>
<script>
/**
 * @author wzy
 * @description 企微通讯录组件   1.员工list  2.组织list
 * @since version 1.0
 * @returns {Array}
 * @param {String} type 'userName'员工 || 'departmentName'部门名称
 * @param {String} openid openId 的 类型
 * @param {Array} datas 数据源
 */
const WWOpenData = window.WWOpenData
export default {
  name: 'SpQwContacts',
  props: {
    type: {
      type: String,
      default: 'userName' // 'userName' || 'departmentName'
    },
    //openid类型
    openid: {
      type: String,
      default: 'userid' // 'userid' || 'departmentid'
    },
    //数据源
    datas: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted () {
    console.log('企微WWOpenData', WWOpenData)
    console.log('SpQwContacts-datas', this.datas)
    console.log('SpQwContacts-openid', this.openid)
    WWOpenData.bind(this.$el)
  },
  methods: {
    setOpenData (val) {
      console.log('setOpenData', val)
    }
  }
}
</script>
